@if (invitations().length > 0) {
  <div class="flex flex-col gap-4">
    @for (inv of invitations(); track inv._id) {
      <div
        class="p-4 sm:p-5 rounded-2xl border-2 border-primary-5/70 dark:border-primary-7/60 bg-gradient-to-r from-primary-1/50 via-primary-1/25 to-transparent dark:from-primary-11/15 dark:via-primary-11/10 dark:to-transparent flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5 shadow-xs hover:shadow-sm transition-all"
      >
        <!-- Côté gauche : Visuel + Informations du bien -->
        <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4 min-w-0 flex-1">
          <!-- Miniature du bien -->
          <div
            class="relative w-24 h-24 sm:w-28 sm:h-28 rounded-xl overflow-hidden shrink-0 border border-neutral-4 dark:border-neutral-7 bg-neutral-2 dark:bg-neutral-1 shadow-2xs"
          >
            @if (getCoverPhotoUrl(inv); as coverUrl) {
              <img
                [src]="coverUrl"
                [alt]="inv.presentation?.title || 'Photo du bien'"
                class="w-full h-full object-cover"
              />
            } @else {
              <div
                class="w-full h-full flex flex-col items-center justify-center bg-primary-2/40 dark:bg-primary-10/20 text-primary dark:text-primary-contrast"
              >
                <mat-icon class="!w-8 !h-8 text-2xl">home</mat-icon>
              </div>
            }
          </div>

          <!-- Détails textuels & badges -->
          <div class="flex flex-col gap-2 min-w-0 flex-1">
            <!-- En-tête : Badge d'invitation & Rôle -->
            <div class="flex flex-wrap items-center gap-2">
              <span
                class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md bg-primary-2 dark:bg-primary-9 text-primary dark:text-white text-xs font-semibold"
              >
                <mat-icon class="!w-3.5 !h-3.5 text-sm">{{
                  getInvitationRole(inv) === PropertyMemberRole.VIEWER ? 'visibility' : 'diversity_3'
                }}</mat-icon>
                <span>{{
                  getInvitationRole(inv) === PropertyMemberRole.VIEWER
                    ? "Invitation d'accès"
                    : 'Invitation à la co-gestion'
                }}</span>
              </span>
              <span
                class="px-2 py-0.5 rounded-md bg-neutral-3 dark:bg-neutral-2 text-neutral-11 dark:text-neutral-9 text-xs font-medium"
              >
                {{ getInvitationRoleLabel(inv) }}
              </span>
            </div>

            <!-- Titre du bien -->
            <h2 class="text-base sm:text-lg font-bold text-neutral-12 truncate m-0">
              {{ inv.presentation?.title || getPropertyTypeLabel(inv.definition?.propertyType) }}
            </h2>

            <!-- Localisation -->
            @if (inv.location?.address?.city; as city) {
              <div class="flex items-center gap-1 text-xs sm:text-sm text-neutral-10 truncate">
                <mat-icon class="!w-4 !h-4 text-base text-neutral-9">place</mat-icon>
                <span>
                  @if (inv.location?.address?.street) {
                    {{ inv.location.address.street }},
                  }
                  {{ city }}
                  @if (inv.location?.address?.zipCode) {
                    ({{ inv.location.address.zipCode }})
                  }
                </span>
              </div>
            }

            <!-- Badges de caractéristiques clés -->
            <div class="flex flex-wrap items-center gap-2 pt-0.5">
              <!-- Prix de vente -->
              @if (inv.financials?.sellingPriceCents; as priceCents) {
                <span
                  class="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-bold bg-primary text-white shadow-2xs"
                >
                  {{ priceCents / 100 | number: '1.0-0' : 'fr-FR' }} €
                </span>
              }

              <!-- Surface -->
              @if (inv.keyInfo?.surface?.habitable; as surface) {
                <span
                  class="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-neutral-3 dark:bg-neutral-2 text-neutral-12 border border-neutral-4 dark:border-neutral-7"
                >
                  {{ surface }} m²
                </span>
              }

              <!-- Type -->
              <span
                class="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-neutral-3 dark:bg-neutral-2 text-neutral-12 border border-neutral-4 dark:border-neutral-7"
              >
                {{ getPropertyTypeLabel(inv.definition?.propertyType) }}
              </span>

              <!-- DPE -->
              @if (inv.dpe?.energyClass; as energy) {
                <span
                  class="inline-flex items-center justify-center font-bold text-xs h-6 w-6 rounded text-white shadow-2xs"
                  [style.background-color]="getDpeColor(energy)"
                  [class.text-black!]="['C', 'D', 'E'].includes(energy.toUpperCase())"
                >
                  {{ energy.toUpperCase() }}
                </span>
              }

              <!-- Invité par -->
              @if (inv.owner?.identity?.firstName; as firstName) {
                <span class="text-xs text-neutral-10 flex items-center gap-1 ml-1">
                  <span>Invité par</span>
                  <strong class="text-neutral-12 font-medium"
                    >{{ firstName }} {{ inv.owner?.identity?.lastName || '' }}</strong
                  >
                </span>
              }
            </div>
          </div>
        </div>

        <!-- Côté droit : Groupe de boutons d'action -->
        <div
          class="flex flex-wrap sm:flex-nowrap items-center gap-2.5 w-full lg:w-auto lg:self-center shrink-0 pt-2 lg:pt-0 border-t lg:border-t-0 border-neutral-4/60 dark:border-neutral-7/60"
        >
          <button
            mat-stroked-button
            type="button"
            class="flex-1 sm:flex-initial !py-2 !px-3.5 text-xs sm:text-sm font-medium"
            (click)="openDetails(inv)"
          >
            <mat-icon class="!w-4 !h-4 text-base mr-1.5">visibility</mat-icon>
            <span>Voir les détails</span>
          </button>
        </div>
      </div>
    }
  </div>
}
